/**
 * Maps the 224x256 logical Donkey Kong playfield onto the canvas:
 * centred between the HUD bars on desktop; at the top with touch controls
 * underneath on mobile.
 */

import { SUB, WORLD_W_PX, WORLD_H_PX } from "../../shared/stage/physics";

const HUD_TOP = 32;
const HUD_BOT = 28;
const MOBILE_CONTROLS_H = 190;

export function computeLayout({ W, H, narrow }) {
  const controlsH = narrow ? MOBILE_CONTROLS_H : 0;
  const availH = H - HUD_TOP - HUD_BOT - controlsH;
  const scale = Math.min(W / WORLD_W_PX, availH / WORLD_H_PX);
  const pw = WORLD_W_PX * scale;
  const ph = WORLD_H_PX * scale;
  const oy = HUD_TOP + (narrow ? 0 : (availH - ph) / 2);
  // Mobile: controls take all the space left under the playfield
  const controlsTop = narrow ? oy + ph + 8 : H - HUD_BOT;
  return {
    scale,
    pw,
    ph,
    ox: (W - pw) / 2,
    oy,
    controlsTop,
    controlsH: narrow ? H - HUD_BOT - controlsTop : 0,
  };
}

/** Logical sub-pixel position → screen pixels. */
export function toScreen(layout, xSub, ySub) {
  return {
    x: layout.ox + (xSub / SUB) * layout.scale,
    y: layout.oy + (ySub / SUB) * layout.scale,
  };
}
